import {defineComponent} from "vue";
import VueCookie from 'vue-cookie'
import loginService from "@/services/login.service";
import http from "@/http-common";
import {useToast} from "vue-toastification";
import {event} from 'vue-gtag'

export default defineComponent({
    name: "ResetPassword",
    setup() {
        const toast = useToast();
        return {toast}
    },
    data() {
        return {
            token: null,
            confirmPassword: '',
            resetPasswordData: {
                new_password: ""
            },
            url: '',
            incorrectCredentials: false,
            userDeactivated: false,
        };
    },
    mounted() {
        this.token = this.$route.query.token;
        this.url = process.env.BASE_URL;
        http.defaults.headers.common['Authorization'] = 'Bearer ' + this.token;

    },
    methods: {
        onSubmit() {
            if (this.confirmPassword != this.resetPasswordData.new_password) {
                this.toast.error("New password and Confirm Password Not Match.");
                return;
            }
            this.userDeactivated = false;
            this.incorrectCredentials = false;
            const loader = this.$loading.show();
            loginService
                .resetPassword(this.resetPasswordData)
                .then((res) => {
                    loader.hide();
                    event('successful registration', {
                        'event_category': 'registration',
                        'event_label': 'register'
                    })
                    this.toast.success("Password Successfully Reset.");

                })
                .catch((err) => {
                    loader.hide();
                    if (err.response.status == 401) {
                        this.toast.error("Your request has expired, please go to login page and click forget password to reset your password.");
                    } else if (err.response.status == 403) {
                        this.userDeactivated = true;
                        this.toast.error("There was an error with your request, please try again. If problem persist, contact our support.");
                    } else {
                        this.toast.error(err.response.data.error);
                        this.incorrectCredentials = true;
                    }
                    console.log(err);
                });
        },
    },
});
